import { MenuItem } from '@mui/material';
import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import { VirtualizedListItemData } from '../Autocomplete.types';

export const VirtualizedList = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLElement>>(({ children, ...props }, ref) => {
    return (
        <div ref={ref} {...props}>
            <Virtuoso
                data={children as VirtualizedListItemData[]}
                style={{ maxHeight: '40vh',
                    height: `calc(40px * ${(children as VirtualizedListItemData[]).length}` }}
                itemContent={(_index: number, data: VirtualizedListItemData) => (
                    <MenuItem value={data[1].value} {...data[0]}>
                        {data[1].menuOptionLabel ? data[1].menuOptionLabel : data[1].label}
                    </MenuItem>
                )}
                overscan={20}
            />
        </div>
    );
});